<template>
  <article
    class="checklist-item"
    :class="item.isChecked === null ? '' : item.isChecked ? 'checked-approved' : 'checked-rejected'"
  >
    <div
      class="d-flex align-center"
      style="gap: 15px;"
    >
      <v-icon :color="item.iconColor">
        {{ item.icon }}
      </v-icon>
      <div
        class="d-flex flex-column"
        style="gap: 10px;"
      >
        <span
          style="font-size: 14px; font-weight: 600;"
          :style="item.isChecked === true ? { color: '#00CD5B' } : item.isChecked === false ? { color: '#FF4C51' } : { color: '#E7E3FC' }"
        >{{ item.title }}</span>
        <span style="font-weight: 500; font-size: 14px; color: #E7E3FC;">{{ item.subtitle }}</span>
      </div>
    </div>
    <div
      class="d-flex align-center"
      style="gap: 10px;"
    >
      <v-tooltip
        v-if="item.isChecked === false"
        top
      >
        <template #activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            @click="$emit('view-problem', item)"
          >
            <v-icon color="#E7E3FC">
              {{ icons.mdiMessageProcessingOutline }}
            </v-icon>
          </v-btn>
        </template>
        <span>Ver Detalhes do Problema</span>
      </v-tooltip>

      <v-tooltip top>
        <template #activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            color="error"
            v-on="on"
            @click="!disabled && item.onRejected(item)"
          >
            <v-icon color="error">
              {{ item.isChecked === false ? icons.mdiThumbDown : icons.mdiThumbDownOutline }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ disabled ? 'Checklist Finalizado' : 'Não Conforme' }}</span>
      </v-tooltip>

      <v-tooltip top>
        <template #activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            color="success"
            v-on="on"
            @click="!disabled && item.onApproved(item)"
          >
            <v-icon color="success">
              {{ item.isChecked === true ? icons.mdiThumbUp : icons.mdiThumbUpOutline }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ disabled ? 'Checklist Finalizado' : 'Conforme' }}</span>
      </v-tooltip>
    </div>
  </article>
</template>

<script>
import {
  mdiMessageProcessingOutline,
  mdiThumbDown, mdiThumbDownOutline, mdiThumbUp, mdiThumbUpOutline,
} from '@mdi/js'

export default {
  name: 'ChecklistItemComponent',
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      icons: {
        mdiThumbDown,
        mdiThumbDownOutline,
        mdiThumbUp,
        mdiThumbUpOutline,
        mdiMessageProcessingOutline,
      },
    }
  },
}
</script>

<style scoped>
.checklist-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 28px;
  border-radius: 10px;
  background: #3B355A;
  border: 1px solid #534D74;
}
.checklist-item.checked-approved {
  border-color: #00CD5B;
  background: #00CD5B0D;
}
.checklist-item.checked-rejected {
  border-color: #FF4C51;
  background: #FF4C510D;
}
</style>
